import { createSlice } from "@reduxjs/toolkit";

export const ENABLED_TREATMENT = "ENABLED";

export interface UserFeatureFlagState {
  featureId: string;
  treatmentId: string;
}

const initialState: UserFeatureFlagState[] = [];

const FeatureFlagSlice = createSlice({
  name: "FeatureFlag",
  initialState,
  reducers: {
    setFeatureFlags(state, action) {
      const { payload } = action;
      return [...state, ...payload];
    },
  },
});

export const { setFeatureFlags } = FeatureFlagSlice.actions;
export default FeatureFlagSlice.reducer;
